import { useFormik } from 'formik';
import { useEffect } from 'react';
import { Sarlaft } from '../../../../../../shared/types/modules/sarlaft';

export const useSarlaftRegisterHistory = (sarlaft?: Sarlaft) => {
    const formik = useFormik({
        initialValues: {
            createdBy: '',
            updatedBy: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const { createdBy, updatedBy } = sarlaft || {};
        formik.setValues({
            createdBy: createdBy
                ? `(${createdBy.username}) ${createdBy.name} ${createdBy.surname}`
                : '',
            updatedBy: updatedBy
                ? `(${updatedBy.username}) ${updatedBy.name} ${updatedBy.surname}`
                : '',
        });
    }, [sarlaft]);

    return {
        formik,
    };
};
